// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ecosystem_ecosystem__z-oq- {
    background: #050518;
  }
  
  .Ecosystem_content__DFvj3 {
    text-align: left;
  }
  
  .Ecosystem_title__447Zp {
    font-size: 3rem;
    margin-bottom: 4rem;
    color: #fff;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
  }
  
  .Ecosystem_projects__HlOwc {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
    margin-bottom: 4rem;
  }
  
  .Ecosystem_project__fDh6p {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 16px;
    padding: 2rem;
    transition: all 0.3s ease;
  }
  
  .Ecosystem_project__fDh6p:hover {
    transform: translateY(-5px);
    background: rgba(255, 255, 255, 0.08);
  }
  
  .Ecosystem_logo__e8Jqa {
    font-size: 3rem;
    margin-bottom: 32px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    height: 64px;
  }
  
  .Ecosystem_projectLogo__o3vKD {
    width: auto;
    height: 100%;
    object-fit: contain;
  }
  
  .Ecosystem_project__fDh6p h3 {
    margin-bottom: 0.5rem;
    color: var(--text);
  }
  
  .Ecosystem_project__fDh6p p {
    color: var(--text-secondary);
    font-size: 0.9rem;
  }
  
  .Ecosystem_community__cTJly {
    padding: 3rem 0;
  }
  
  .Ecosystem_community__cTJly h3 {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    color: var(--text);
  }
  
  .Ecosystem_links__SvjZH {
    display: flex;
    gap: 1rem;
    justify-content: center;
    margin-bottom: 2rem;
  }
  
  .Ecosystem_link__pWbFx {
    color: var(--text);
    text-decoration: none;
    font-weight: 500;
    padding: 0.5rem 1rem;
    transition: all 0.3s ease;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 1rem;
  }
  
  .Ecosystem_link__pWbFx:hover {
    color: var(--secondary);
  }
  
  .Ecosystem_grantsCta__Gh\\+fM {
    display: inline-block;
    padding: 1rem 2rem;
    border-radius: 8px;
    background: linear-gradient(45deg, var(--primary), var(--secondary));
    color: white;
    text-decoration: none;
    font-weight: 600;
    transition: all 0.3s ease;
    border: none;
    cursor: pointer;
    font-size: 1rem;
  }
  
  .Ecosystem_grantsCta__Gh\\+fM:hover {
    transform: translateY(-2px);
    filter: brightness(1.1);
  }
  
  @media (max-width: 768px) {
    .Ecosystem_title__447Zp {
      font-size: 2rem;
      margin-bottom: 2rem;
    }
    
    .Ecosystem_projects__HlOwc {
      grid-template-columns: 1fr;
    }
    
    .Ecosystem_links__SvjZH {
      flex-direction: column;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/Ecosystem/Ecosystem.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;IACnB,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;IAC3B,qCAAqC;EACvC;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,2BAA2B;IAC3B,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;IAC5B,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,oBAAoB;IACpB,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,oEAAoE;IACpE,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE;MACE,eAAe;MACf,mBAAmB;IACrB;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,sBAAsB;IACxB;EACF","sourcesContent":[".ecosystem {\n    background: #050518;\n  }\n  \n  .content {\n    text-align: left;\n  }\n  \n  .title {\n    font-size: 3rem;\n    margin-bottom: 4rem;\n    color: #fff;\n    max-width: 800px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n  \n  .projects {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 2rem;\n    margin-bottom: 4rem;\n  }\n  \n  .project {\n    background: rgba(255, 255, 255, 0.05);\n    border-radius: 16px;\n    padding: 2rem;\n    transition: all 0.3s ease;\n  }\n  \n  .project:hover {\n    transform: translateY(-5px);\n    background: rgba(255, 255, 255, 0.08);\n  }\n  \n  .logo {\n    font-size: 3rem;\n    margin-bottom: 32px;\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-start;\n    height: 64px;\n  }\n  \n  .projectLogo {\n    width: auto;\n    height: 100%;\n    object-fit: contain;\n  }\n  \n  .project h3 {\n    margin-bottom: 0.5rem;\n    color: var(--text);\n  }\n  \n  .project p {\n    color: var(--text-secondary);\n    font-size: 0.9rem;\n  }\n  \n  .community {\n    padding: 3rem 0;\n  }\n  \n  .community h3 {\n    font-size: 1.5rem;\n    margin-bottom: 1.5rem;\n    color: var(--text);\n  }\n  \n  .links {\n    display: flex;\n    gap: 1rem;\n    justify-content: center;\n    margin-bottom: 2rem;\n  }\n  \n  .link {\n    color: var(--text);\n    text-decoration: none;\n    font-weight: 500;\n    padding: 0.5rem 1rem;\n    transition: all 0.3s ease;\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 1rem;\n  }\n  \n  .link:hover {\n    color: var(--secondary);\n  }\n  \n  .grantsCta {\n    display: inline-block;\n    padding: 1rem 2rem;\n    border-radius: 8px;\n    background: linear-gradient(45deg, var(--primary), var(--secondary));\n    color: white;\n    text-decoration: none;\n    font-weight: 600;\n    transition: all 0.3s ease;\n    border: none;\n    cursor: pointer;\n    font-size: 1rem;\n  }\n  \n  .grantsCta:hover {\n    transform: translateY(-2px);\n    filter: brightness(1.1);\n  }\n  \n  @media (max-width: 768px) {\n    .title {\n      font-size: 2rem;\n      margin-bottom: 2rem;\n    }\n    \n    .projects {\n      grid-template-columns: 1fr;\n    }\n    \n    .links {\n      flex-direction: column;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ecosystem": `Ecosystem_ecosystem__z-oq-`,
	"content": `Ecosystem_content__DFvj3`,
	"title": `Ecosystem_title__447Zp`,
	"projects": `Ecosystem_projects__HlOwc`,
	"project": `Ecosystem_project__fDh6p`,
	"logo": `Ecosystem_logo__e8Jqa`,
	"projectLogo": `Ecosystem_projectLogo__o3vKD`,
	"community": `Ecosystem_community__cTJly`,
	"links": `Ecosystem_links__SvjZH`,
	"link": `Ecosystem_link__pWbFx`,
	"grantsCta": `Ecosystem_grantsCta__Gh+fM`
};
export default ___CSS_LOADER_EXPORT___;
